import React from 'react'

import Tippy, { TippyProps } from '@tippyjs/react'

const Tooltip: React.FC<TippyProps> = (props: TippyProps) => (
  <Tippy className="bg-black-bg shadow" {...props} />
)

export default Tooltip
